import Letterhead from "../Reusable/Letterhead2";
import MetaInfo from "../Reusable/MetaInfo2";
import SubjectLine from "../Reusable/SubjectLine2";
import Signature from "../Reusable/Signature2";

interface DemotionLetterProps {
  refNo: string;
  date: string;
  name: string;
  address: string;
  Demoted_Role: string;
  Role: string;
  effectiveDate: string;
}

const DemotionLetter = ({ refNo, date, name, address, Demoted_Role, Role, effectiveDate }: DemotionLetterProps) => (
  <div className="p-10 rounded-lg max-w-2xl mx-auto space-y-4">
    <Letterhead/>
    <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
    <MetaInfo refNo={refNo} date={date} name={name} address={address} />
    <SubjectLine subject="Demotion Letter" />

    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    This letter serves as a formal notification regarding the decision of the management to <b>reassign your role</b> within the organization. After careful evaluation of your performance during the past period, 
    it has been observed that your work has not consistently met the
    expectations required for your current position of <b>{Role}</b>.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    Accordingly, effective from <b>{effectiveDate}</b>, you will be reassigned to the role of <b>{Demoted_Role}</b>. 
    The compensation and benefits applicable to the newrole will be as perthe company’s policies.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
     This action is being taken to provide you with an opportunity to realign yourself with organizational requirements and to perform in a role better suited to your current capabilities. 
     We sincerely hope that you will treat this as an opportunity for improvement and growth, 
     and that you will continue to contribute positively to the organization.   
    </p>

    <Signature />
  </div>
);

export default DemotionLetter;
